import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IconButton, withStyles } from "@material-ui/core";
import { SortableTreeWithoutDndContext as SortableTree } from "react-sortable-tree";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import WBTheme from "./Tree/index";
import styles from "../wrappers/admin/Admin.Styles";
import { userInRoles, UserRoleTypeEnum } from "../services/authService";
import {
  GetHierarchyElements,
  CreateHierarchyElement,
  UpdateHierarchyElement,
  DeleteHierarchyElement
} from "../services/hierarchyService";
import * as AccountHierarchyActions from "../store/AccountHierarchy";
import * as SnackbarActions from "../store/SnackbarStore";
import * as AccountActions from "../store/AccountStore";
import { LoadRollupModal } from "../store/RollupModalStore";
import RollupModalForm from "./RollupModal";
import { RollupFormMode } from "./RollupModal";
import {
  addNodeUnderParent,
  changeNodeAtPath,
  insertNode,
  removeNodeAtPath,
  getTreeFromFlatData
} from "react-sortable-tree";
import filter from "lodash/filter";
import WBToolbar, { WBToolbarMode } from "./WBToolbar";

class Hierarchy extends Component {
  state = {
    searchString: "",
    searchFocusIndex: 0,
    searchFoundCount: null,
    hierarchyId: 0,
    rollupModalOpen: false,
    treeData: []
  };

  constructor(props) {
    super(props);
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps = async nextProps => {
    const { hierarchyId, setHierarchyElements } = nextProps;
    if (hierarchyId !== this.state.hierarchyId) {
      const hierarchyElements = await GetHierarchyElements(hierarchyId);
      const hierarchyTree = hierarchyElements
        ? getTreeFromFlatData({
            flatData: hierarchyElements.map(i => {
              return {
                id: i.id,
                title: i.name,
                parentId: i.parentId,
                nodeType: i.entityId && i.entityId > 0 ? "item" : "rollup"
              };
            }),
            rootKey: 0
          })
        : [];
      this.setState({
        treeData: hierarchyTree,
        hierarchyId: hierarchyId
      });
      setHierarchyElements(hierarchyElements);
    }
  };

  getNodeKey = ({ node }) => node.id;

  handleRollupClose = (hierarchyElement, mode) => {
    const { setHierarchyElements, hierarchyElements } = this.props;
    if (hierarchyElement) {
      let treeData = this.state.treeData;

      if (mode === RollupFormMode.CREATE) {
        if (this.state.currentNode) {
          treeData = addNodeUnderParent({
            treeData: this.state.treeData,
            parentKey: this.state.currentNode ? this.state.currentNode.id : 0,
            expandParent: true,
            getNodeKey: this.getNodeKey,
            newNode: {
              id: hierarchyElement.id,
              title: hierarchyElement.name,
              parentId: hierarchyElement.parentId,
              nodeType: "rollup"
            }
          }).treeData;
        } else {
          treeData = insertNode({
            depth: 0,
            treeData: this.state.treeData,
            getNodeKey: this.getNodeKey,
            newNode: {
              id: hierarchyElement.id,
              title: hierarchyElement.name,
              parentId: hierarchyElement.parentId,
              nodeType: "rollup"
            }
          }).treeData;
        }
        setHierarchyElements([...hierarchyElements, hierarchyElement]);
      } else if (mode === RollupFormMode.EDIT) {
        const { currentNode } = this.state;
        currentNode.title = hierarchyElement.name;
        setHierarchyElements(
          hierarchyElements.map(h => {
            return h.id === hierarchyElement.id ? hierarchyElement : h;
          })
        );
      }

      this.setState({
        treeData: treeData,
        rollupModalOpen: false
      });
    }
  };

  onTreeChange = treeData => {
    this.setState({ treeData });
  };

  onTreeMove = async treeObj => {
    let hierarchyMode = this.getMode();
    debugger;

    if (hierarchyMode === HierarchyMode.EDIT) {
      const { sendError, setHierarchyElements, hierarchyElements } = this.props;
      let hierarchyElement = hierarchyElements.find(
        e => e.id === treeObj.node.id
      );
      const nextId = treeObj.nextParentNode ? treeObj.nextParentNode.id : 0;

      if (treeObj.node.type === "itemDrop") {
        hierarchyElement = {
          id: 0,
          parentId: nextId,
          hierarchyId: this.state.hierarchyId,
          elementTypeId: 2,
          name: treeObj.node.name,
          entityId: treeObj.node.id,
          invertSign: false
        };
        try {
          hierarchyElement = await CreateHierarchyElement(hierarchyElement);
        } catch (error) {
          sendError(error);
        }
        if (hierarchyElement) {
          const newNode = {
            ...treeObj.node,
            id: hierarchyElement.id,
            title: treeObj.node.name,
            parentId: nextId,
            nodeType: "item",
            type: undefined
          };
          this.onTreeChange(
            changeNodeAtPath({
              treeData: treeObj.treeData,
              path: treeObj.path,
              getNodeKey: this.getNodeKey,
              newNode
            })
          );
          setHierarchyElements([...hierarchyElements, hierarchyElement]);
          return;
        }
      } else {
        try {
          await UpdateHierarchyElement({
            ...hierarchyElement,
            parentId: nextId
          });
        } catch (error) {
          sendError(error);
        }
      }
    }
  };

  onAddRollup = node => {
    const { LoadRollupModal } = this.props;
    const parentId = node ? node.id : 0;

    LoadRollupModal({
      id: 0,
      parentId: parentId,
      hierarchyId: this.state.hierarchyId,
      elementTypeId: 1,
      invertSign: false
    });
    this.setState({ rollupModalOpen: true, currentNode: node });
  };

  onEditRollup = node => {
    const { LoadRollupModal, hierarchyElements } = this.props;

    let hierarchyElement = hierarchyElements.find(e => e.id === node.id);

    LoadRollupModal(hierarchyElement);
    this.setState({ rollupModalOpen: true, currentNode: node });
  };

  onDeleteRollup = async (node, path) => {
    const { setHierarchyElements, hierarchyElements } = this.props;
    const hierarchyElement = hierarchyElements.find(e => e.id === node.id);
    if (hierarchyElement) {
      await DeleteHierarchyElement(hierarchyElement);
      setHierarchyElements(
        filter(hierarchyElements, h => h.id !== hierarchyElement.id)
      );
      const treeData = removeNodeAtPath({
        treeData: this.state.treeData,
        path,
        getNodeKey: this.getNodeKey
      });
      this.setState({
        treeData: treeData
      });
    }
  };

  getDeleteButton = (node, path, classes) => {
    return (
      <IconButton
        style={{
          width: "20px",
          height: "20px",
          padding: "0px"
        }}
        className={classes.button}
        onClick={() => {
          this.onDeleteRollup(node, path);
        }}
      >
        <DeleteIcon style={{ fontSize: "16px" }} />
      </IconButton>
    );
  };

  getEditButton = (node, path, classes) => {
    return (
      <IconButton
        style={{
          width: "20px",
          height: "20px",
          padding: "0px"
        }}
        onClick={() => {
          this.onEditRollup(node);
        }}
      >
        <EditIcon style={{ fontSize: "16px" }} />
      </IconButton>
    );
  };

  getMode = () => {
    let { hierarchyMode } = this.props;
    if (!hierarchyMode) {
      hierarchyMode = HierarchyMode.EDIT;
    }
    return hierarchyMode;
  };

  getNodeButtons = (node, path, classes) => {
    let hierarchyMode = this.getMode();

    if (hierarchyMode === HierarchyMode.READ) return [];

    if (node.nodeType === "item") {
      return [
        this.getEditButton(node, path, classes),
        this.getDeleteButton(node, path, classes)
      ];
    } else {
      let buttons = [
        <IconButton
          style={{
            width: "20px",
            height: "20px",
            padding: "0px"
          }}
          onClick={() => {
            this.onAddRollup(node);
          }}
        >
          <AddIcon style={{ fontSize: "16px" }} />
        </IconButton>,
        this.getEditButton(node, path, classes)
      ];

      if (!node.children || node.children.length === 0) {
        buttons.push(this.getDeleteButton(node, path, classes));
      }

      return buttons;
    }
  };

  render() {
    const { searchString, searchFocusIndex, searchFoundCount } = this.state;
    const { classes, dndType, hierarchyTypeId, user } = this.props;
    let hierarchyMode = this.getMode();

    // Case insensitive search of `node.title`
    const customSearchMethod = ({ node, searchQuery }) =>
      searchQuery &&
      node &&
      node.title &&
      node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;

    const selectPrevMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
            : searchFoundCount - 1
      });

    const selectNextMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFocusIndex + 1) % searchFoundCount
            : 0
      });

    return (
      <div style={{ position: "relative" }}>
        <WBToolbar
          onFilter={filterText => {
            this.setState({ searchString: filterText });
          }}
          onNext={selectNextMatch}
          onPrev={selectPrevMatch}
          onAdd={this.onAddRollup}
          wbToolbarMode={
            hierarchyMode === HierarchyMode.EDIT
              ? WBToolbarMode.EDIT
              : WBToolbarMode.READ
          }
        />
        <hr style={{ margin: 2 }} />
        <div style={{ height: 500 }}>
          <SortableTree
            treeData={this.state.treeData}
            onChange={this.onTreeChange}
            onMoveNode={this.onTreeMove}
            getNodeKey={this.getNodeKey}
            canDrag={() => {
              return hierarchyMode === HierarchyMode.EDIT;
            }}
            canDrop={({ node, nextParent }) => {
              if (hierarchyMode === HierarchyMode.READ) {
                return false;
              }
              if (nextParent) {
                return nextParent.nodeType === "rollup";
              }
              return true;
            }}
            searchMethod={customSearchMethod}
            searchQuery={searchString}
            searchFocusOffset={searchFocusIndex}
            searchFinishCallback={matches =>
              this.setState({
                searchFoundCount: matches.length,
                searchFocusIndex:
                  matches.length > 0 ? searchFocusIndex % matches.length : 0
              })
            }
            theme={WBTheme}
            dndType={dndType}
            generateNodeProps={({ node, path }) => ({
              buttons: this.getNodeButtons(node, path, classes)
            })}
          />
          {this.state.rollupModalOpen && (
            <RollupModalForm
              open={this.state.rollupModalOpen}
              handleClose={this.handleRollupClose}
              hierarchyTypeId={hierarchyTypeId}
            />
          )}
        </div>
      </div>
    );
  }
}

Hierarchy.propTypes = {
  dndType: PropTypes.string,
  hierarchyId: PropTypes.number,
  hierarchyElements: PropTypes.array,
  hierarchyTypeId: PropTypes.number
};

export const HierarchyMode = Object.freeze({
  READ: Symbol("read"),
  EDIT: Symbol("edit")
});

export default connect(
  state => {
    return {
      accounts: state.accounts.accounts || {},
      hierarchyElements: state.accountHierarchy.hierarchyElements,
      user: state.user.user
    };
  },
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        AccountHierarchyActions.actionCreators,
        AccountActions.actionCreators,
        {
          LoadRollupModal: LoadRollupModal
        },
        SnackbarActions.actionCreators
      ),
      dispatch
    )
)(withStyles(styles)(Hierarchy));
